// 2. This code loads the IFrame Player API code asynchronously.
var tag = document.createElement('script');
tag.src = "https://www.youtube.com/iframe_api";
var firstScriptTag = document.getElementsByTagName('script')[0];
firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

window.videoPlayers = {};
let videoPlayer;

// event that will be fired when the player is fully loaded
function onPlayerReady(event) {
    jQuery(event.target.a).parents('.c-video--player').addClass('video-loaded');

    event.target.playVideo();
}

// event that will be fired when the state of the player changes
function onPlayerStateChange(event) {
    var target = jQuery(event.target.a).parent();
    if (event.data === 0 || event.data === 2) {
        target.addClass('video-paused');
        target.parent().addClass('video-paused');
    } else {
        target.removeClass('video-paused');
        target.parent().addClass('video-paused');
    }
}
function setupVideo(id) {
    var fullscreen = 0;
    window.videoPlayers[id] = new YT.Player('c-video--' + id, {
        height: '390',
        width: '640',
        videoId: id,
        rel: 0,
        autoplay: 1,
        playerVars: {'autoplay': 1, 'showinfo': 0, 'rel': 0, 'controls': 1, 'autohide': 1, 'wmode': 'opaque'},
        events: {
            'onReady': onPlayerReady,
            'onStateChange': onPlayerStateChange
        }
    });
}
function watchVideoClicks() {
    jQuery('.c-video--player').on('click', function () {
        var _this = jQuery(this);
        if (_this.data('type') === "youtube") {
            var id = _this.data('video-id');
            if (_this.hasClass('video-loaded')) {
                window.videoPlayers[id].playVideo();
            } else {
                setupVideo(id, _this.data('video-url'));
                _this.addClass('video-loaded');
            }
            var targetID = _this.data('video-id');
            jQuery('.c-video--player').each(function () {
                var current = jQuery(this);
                var current_id = current.data('video-id');
                if (current_id !== targetID) {
                    if (typeof window.videoPlayers[current_id] !== "undefined") {

                        if (typeof window.videoPlayers[current_id].pauseVideo === 'function') {
                            window.videoPlayers[current_id].pauseVideo();
                        }
                    }
                }
            });
            if (jQuery(window).width() < 1000 && window.innerWidth > window.innerHeight ) {
                var doc = window.document;
                var iframe = _this.find('iframe')[0];
                var requestFullScreen = iframe.requestFullscreen || iframe.mozRequestFullScreen || iframe.webkitRequestFullScreen || iframe.msRequestFullscreen;

                if(!doc.fullscreenElement && !doc.mozFullScreenElement && !doc.webkitFullscreenElement && !doc.msFullscreenElement) {
                    requestFullScreen.call(iframe);
                }
            }
        } else {
            // VIMEO
        }
    });
    jQuery('.c-video--player__autoplay').each(function () {
        var _this = jQuery(this);
        if (_this.data('type') === "youtube") {
            var id = _this.data('video-id');
            if (_this.hasClass('video-loaded')) {
                window.videoPlayers[id].playVideo();
            } else {
                setupVideo(id, _this.data('video-url'));
                _this.addClass('video-loaded');
            }
            var targetID = _this.data('video-id');
            jQuery('.c-video--player').each(function () {
                var current = jQuery(this);
                var current_id = current.data('video-id');
                if (current_id !== targetID) {
                    if (typeof window.videoPlayers[current_id] !== "undefined") {

                        if (typeof window.videoPlayers[current_id].pauseVideo === 'function') {
                            window.videoPlayers[current_id].pauseVideo();
                        }
                    }
                }
            });
        } else {
            // VIMEO
        }
    });

    jQuery('.js-play-video').on('click', function (e) {
        e.preventDefault();

        const getMeTo = $('#js-video-player');
        window.scrollTo({
            top: getMeTo.offset().top - 100,
        });

        setupVideo2($(this).data('id'), true);
    });
    const id = jQuery('.js-play-video').first().data('id');
    if(id) {
        setupVideo2(id);
    }
}

function setupVideo2(url, autoplay) {
    const id = youtube_parser(url);
    if(videoPlayer) {
        // destroy old player
        videoPlayer.pauseVideo();
        videoPlayer = null;
        jQuery('#js-video-player-container').html('').html('<div id="js-video-player" class="w-full aspect-video"></div>');
    }
    videoPlayer = new YT.Player('js-video-player', {
        height: '390',
        width: '640',
        videoId: id,
        rel: 0,
        autoplay: 1,
        playerVars: {
            'autoplay': autoplay, //only autoplay videos on click
            'showinfo': 0,
            'rel': 0,
            'controls': 1,
            'autohide': 1,
            'wmode': 'opaque'
        },
    });
    const fitVid = $('#js-video-player')[0];
    fitVid.removeAttribute('height');
    fitVid.removeAttribute('width');
}

function youtube_parser(url){
    var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
    var match = url.match(regExp);
    return (match&&match[7].length==11)? match[7] : false;
}


window.onYouTubeIframeAPIReady = function(pid) {
    watchVideoClicks();
}
